module.exports = __webpack_public_path__ + "img/QCN.818c8abd.svg";